import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

import ClientFullDetailsComponent from '@/components/ClientsPage/ClientFullDetails/ClientFullDetailsComponent';
import { useClients } from '@/hooks/useClients';

const ClientFullDetailsContainer = () => {
  const { id, status } = useParams();
  const intl = useIntl();
  const { useClientFullDetails } = useClients();
  const { data: details, isLoading } = useClientFullDetails(id);

  const hasBillingAddress = useMemo(() => {
    if (!details?.billing_address) return false;
    const addr = details.billing_address;
    return !!(
      addr.zipcode ||
      addr.street ||
      addr.number ||
      addr.complement ||
      addr.neighborhood ||
      addr.city ||
      addr.state
    );
  }, [details]);

  return (
    <ClientFullDetailsComponent
      details={details}
      id={id}
      intl={intl}
      hasBillingAddress={hasBillingAddress}
      loading={isLoading}
      status={status}
    />
  );
};

export default ClientFullDetailsContainer;

